import React, { useState, useEffect } from 'react';
import { Layout, Menu, Breadcrumb } from 'antd';
import { useNavigate } from 'react-router-dom';

import { Link, useLocation } from 'react-router-dom';
import { HomeOutlined, UploadOutlined, SettingOutlined, SwapOutlined, LogoutOutlined, HomeFilled} from '@ant-design/icons'; // Import icons
import { useAuth } from './AuthContext';
import { getEndpoint } from '../utils/endpoints';

const { Header, Content } = Layout;

  
const breadcrumbNameMap: { [key: string]: string } = {
  '/upload': 'Upload',
  '/translate': 'Translate',
  '/settings': 'Settings',
  '/document': 'Document Details' // example if you have nested routes
};

type AppLayoutProps = {
    children: React.ReactElement<ChildProps>;
}

interface ChildProps {
}


const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
    const location = useLocation();
  const { logout } = useAuth(); // Destructure logout from useAuth

  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  const [docLabel, setDocLabel] = useState<string>("");

  // fetch the real document name for /document2 and /pe breadcrumbs
  useEffect(() => {
    const m = location.pathname.match(/^\/(?:document2|pe)\/([^/]+)/);
    if (!m) { setDocLabel(""); return; }
    fetch(`${getEndpoint('BACKEND')}/getDocumentsDetails/v2/${m[1]}/`, {
      headers: { Accept: 'application/json' },
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => setDocLabel(d?.document_name || ""))
      .catch(() => setDocLabel(""));
  }, [location.pathname]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  const breadcrumbItems = () => {
    const url = location.pathname;
    const docMatch = url.match(/^\/(?:document2|pe)\/([^/]+)/);
    const uuid = docMatch ? docMatch[1] : null;
    const isPe = url.startsWith("/pe/");

    return (
      <>
        <Breadcrumb.Item key="/dashboard2">
          <Link to="/dashboard2">
            <HomeFilled /> Dashboard
          </Link>
        </Breadcrumb.Item>

        {uuid && (
          <Breadcrumb.Item key="doc">
            {isPe ? (
              <Link to={`/document2/${uuid}`}>{docLabel || "Documento"}</Link>
            ) : (
              docLabel || "Documento"
            )}
          </Breadcrumb.Item>
        )}
        {isPe && <Breadcrumb.Item key="pe">Post-editing</Breadcrumb.Item>}
        {breadcrumbNameMap[url] && (
          <Breadcrumb.Item key="page">{breadcrumbNameMap[url]}</Breadcrumb.Item>
        )}
      </>
    );
  };
  

  const handleMenuClick = (menuItem: string) => {
    // Add logic to handle the menu item click, e.g., navigate to the corresponding page
    switch (menuItem) {
        case 'dashboard':
            navigate('/dashboard2');
            break;
        case 'translate':
            navigate('/translate');
            break;
        case 'upload':
            navigate('/upload');
            break;
        case 'testtranslation':
          navigate('/testtranslation');
          break;
          case 'settings':
            navigate('/settings');
            break;
  
        case 'logout':
            logout();  // Call the logout function
            navigate('/'); // Redirect user to the login page
    
            break;
        default:
            break;
        }
  };


  return (
    <Layout>
      <Header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', zIndex: 2, position: 'relative', background: 'linear-gradient(90deg, #0b1f3a 0%, #1b2b6b 60%, #3a2b7a 100%)', padding: '0 24px' }}>
      <Link to="/dashboard2" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <img src={`${process.env.PUBLIC_URL}/favicon.svg`} alt="Patren" width={28} height={28} style={{ borderRadius: 7 }} />
        <span style={{ color: '#fff', fontWeight: 700, fontSize: 16, letterSpacing: 0.2 }}>Patren</span>
        <span style={{ color: '#9db2ff', fontWeight: 500, fontSize: 12 }}>@Bifa</span>
      </Link>
      <Menu
            theme="dark"
            mode="horizontal"
            onClick={({ key }) => handleMenuClick(key)}
            style={{ flex: 1, justifyContent: 'end', zIndex: 2, position: 'relative', background: 'transparent' }} // Align menu items to the right
          >
            <Menu.Item key="dashboard" icon={<HomeOutlined />}>
              Dashboard V2
            </Menu.Item>
            {/*<Menu.Item key="translate" icon={<SwapOutlined />}>
              Translate
            </Menu.Item>

            <Menu.Item key="upload" icon={<UploadOutlined />}>
              Upload
            </Menu.Item>
            
            <Menu.Item key="memories" icon={<SettingOutlined />}>
              Manage Memories 
            </Menu.Item>            
            */
            }
            <Menu.Item key="testtranslation" icon={<SwapOutlined />}>
              Test Translation V2
            </Menu.Item>

            <Menu.Item key="settings" icon={<SettingOutlined />}>
              Settings
            </Menu.Item>
            <Menu.Item key="logout" icon={<LogoutOutlined />}>
              Logout
            </Menu.Item>           
          </Menu>
      </Header>
      <Content style={{ zIndex: 1, position: 'relative' }}>
        <Breadcrumb style={{ margin: '20px', zIndex: 2, position: 'relative' }}>
          {breadcrumbItems()}
        </Breadcrumb>
        
        
    {children}


      </Content>
    </Layout>
  );
};

export default AppLayout;
